import { usePublicationByStockLibbyCall } from "./PublicationByStockBusinessGenerated";
import { Stock } from "../../models";

export const usePublicationByStock = (zone: string) => usePublicationByStockLibbyCall<Stock>({ methodName: "getByStock", params: [zone] });
